import React from 'react';

interface AuthPageWrapperProps {
  children: React.ReactNode;
}

export const AuthPageWrapper: React.FC<AuthPageWrapperProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-celebration-pink/8 blur-3xl -translate-y-1/3 translate-x-1/4" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-celebration-purple/8 blur-3xl translate-y-1/3 -translate-x-1/4" />
        <div className="absolute top-1/2 left-1/2 w-[350px] h-[350px] rounded-full bg-celebration-blue/5 blur-3xl -translate-x-1/2 -translate-y-1/2" />
      </div>

      {/* Header branding */}
      <div className="w-full pt-8 pb-4 text-center">
        <a href="/" className="inline-flex items-center gap-2.5 group">
          <img
            src="/assets/curvato-logo.svg"
            alt="Curvato"
            className="w-10 h-10 group-hover:scale-105 transition-transform"
          />
          <span className="font-display font-bold text-2xl bg-clip-text text-transparent bg-gradient-to-r from-primary to-celebration-purple">
            curvato.us
          </span>
        </a>
        <p className="mt-2 text-sm text-muted-foreground">
          Plan unforgettable celebrations — effortlessly
        </p>
      </div>

      {/* SuperTokens auth form */}
      <div className="flex-1 flex items-start justify-center pt-4 pb-12 px-4">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>

      {/* Footer */}
      <div className="pb-6 text-center">
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} Curvato. All rights reserved.
        </p>
      </div>
    </div>
  );
};
